export enum ChainId {
  ARBITRUM = 42161,
  ARBITRUM_TESTNET = 421614, // ARBITRUM SEPOLIA (79377087078960 Arbitrum Rinkeby is deprecated)
  AVALANCHE = 43114,
  AVALANCHE_TESTNET = 43113,
  BASE = 8453,
  BSC = 56,
  BSC_TESTNET = 97,
  BLAST = 81457,
  CELO = 42220,
  CORE = 1116,
  CRONOS = 25,
  ETHEREUM = 1,
  FANTOM = 250,
  FANTOM_TESTNET = 4002,
  FUSE = 122,
  HARDHAT = 31337,
  HARMONY = 1666600000,
  HARMONY_TESTNET = 1666700000,
  HECO = 128,
  HECO_TESTNET = 256,
  LINEA = 59144,
  MANTLE = 5000,
  MANTLE_TESTNET = 5003,
  MATIC = 137,
  MATIC_TESTNET = 80002, // AMOY (80001 Mumbai is deprecated)
  MOONBEAM = 1284,
  MOONBEAM_TESTNET = 1287,
  MOONRIVER = 1285,
  OKEX = 66,
  OKEX_TESTNET = 65,
  OPTIMISM = 10,
  PALM = 11297108109,
  PALM_TESTNET = 11297108099,
  PULSECHAIN = 369,
  SCROLL = 534352,
  TAIKO = 167000,
  TAIKO_TESTNET = 167009,
  TELOS = 40,
  TELOS_TESTNET = 41,
  XDAI = 100,
  ZKSYNC = 324,
}
